import Head from 'next/head';
import { useRouter } from 'next/router';
import { PRODUCTS_RENDER_COUNTS } from '@features/categories/const';
import { PUBLIC_HOST } from '@config/index';
type PropsType = {
  paginationCount: number;
  currentUrl: string;
};
const CategoriesSeoPaginationLinks = ({
  paginationCount,
  currentUrl
}: PropsType) => {
  const {
    locale,
    defaultLocale,
    asPath
  } = useRouter();
  const url = new URL(asPath, PUBLIC_HOST);
  const currentPage = parseInt(url.searchParams.get('page') || '1', 10);
  const localePrefix = locale !== defaultLocale ? `/${locale}` : '';
  const href = `${PUBLIC_HOST}${localePrefix}/${currentUrl}`;
  const totalPages = Math.ceil(paginationCount / PRODUCTS_RENDER_COUNTS);
  return <Head>
      {currentPage > 1 && <link rel="prev" href={`${href}?page=${currentPage - 1}`} />}
      {currentPage < totalPages && <link rel="next" href={`${href}?page=${currentPage + 1}`} />}
    </Head>;
};
export default CategoriesSeoPaginationLinks;